import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-assets-introduction",
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: "./assets-introduction.component.html",
  styleUrls: ["./assets-introduction.component.scss"]
})
export class AssetsIntroductionComponent {}
